import * as actionTypes from "./actionTypes"

const initialState = {
  isMaintenanceMode: false,
  loading: false,
  error: null,
}

const maintenanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MAINTENANCE_MODE:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case actionTypes.FETCH_MAINTENANCE_MODE_SUCCESS:
      return {
        ...state,
        isMaintenanceMode: action.payload,
        loading: false,
        error: null,
      }
    case actionTypes.FETCH_MAINTENANCE_MODE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case actionTypes.SET_MAINTENANCE_MODE:
      return {
        ...state,
        isMaintenanceMode: action.payload,
      }
    default:
      return state
  }
}

export default maintenanceReducer
